module.exports = __webpack_public_path__ + "img/20191107161818842.24c43ee2.jpg";